import { gql } from 'graphql-tag';

const EVENT_LIST_FRAGMENT = gql`
  fragment EventListFields on Event {
    id
    accountId
    eventTypeId
    ownerUserId
    contactId
    locationId
    done
    name
    isAllDay
    startsAt
    endsAt
    recurrenceSeriesId
    eventType {
      id
      name
      color
    }
    ownerUser {
      id
      firstName
      lastName
    }
    contact {
      id
      firstName
      lastName
    }
  }
`;

const EVENT_DETAIL_FRAGMENT = gql`
  fragment EventDetailFields on Event {
    id
    accountId
    eventTypeId
    ownerUserId
    contactId
    locationId
    done
    doneDate
    doneUserId
    name
    description
    isAllDay
    startsAt
    endsAt
    createdAt
    updatedAt
    deletedAt
    recurrence {
      rule {
        frequency
        interval
        weekdays
        monthDay
        monthWeekday {
          week
          weekday
        }
      }
      end {
        type
        endDate
        occurrenceCount
      }
    }
    recurrenceSeriesId
    recurrenceOccurrenceIndex
    eventType {
      id
      name
      color
    }
    contact {
      id
      firstName
      lastName
      email
      phone
      company
      address
    }
    ownerUser {
      id
      firstName
      lastName
    }
  }
`;

export const GET_EVENTS = gql`
  ${EVENT_LIST_FRAGMENT}
  query GetEvents($skip: Int, $take: Int, $filters: EventFilterInput, $sortField: String, $sortDirection: SortDirection) {
    events(skip: $skip, take: $take, filters: $filters, sortField: $sortField, sortDirection: $sortDirection) {
      data {
        ...EventListFields
      }
      total
      page
      limit
    }
  }
`;

export const GET_EVENT = gql`
  ${EVENT_DETAIL_FRAGMENT}
  query GetEvent($id: ID!) {
    event(id: $id) {
      ...EventDetailFields
      doneUser {
        id
        firstName
        lastName
      }
    }
  }
`;

export const GET_APPOINTMENT_STATISTICS = gql`
  query GetAppointmentStatistics {
    appointmentStatistics {
      appointmentsToday
      appointmentsThisWeek
    }
  }
`;
